import React, { useState } from "react";
import deleteImg from "../../Assets/Images/Configuration/delete-modal.png";
import { Button, Modal } from "react-bootstrap";
import { apiCall } from "../../utils/axiosService";
import { commonService } from "../../utils/commonService";
import { useDispatch } from "react-redux";
import { callApiOfSnapShot } from "../../utils/slices/callApiAgainSlice";
import {
  errorToastMessage,
  successToastMessage,
} from "../../utils/toastMessage";

function ConfirmationAlertModal({
  showModal,
  acceptAlert,
  denyAlert,
  mainMessage = "",
  subMessage = "",
}) {
  return (
    <Modal
      className="DeleteItemModalMain"
      centered
      show={showModal}
      onHide={denyAlert}
    >
      <Modal.Body>
        <div className="delete-modal-content text-center">
          <img src={deleteImg} alt="delete" />
          <h2>{mainMessage}</h2>
          <p>{subMessage}</p>

          <div className="delete-modal-content-btns d-flex justify-content-center gap-2 mt-3">
            <button id={commonService.generateGlobalClickTrackerID("ConfirmationAlertModal", "yes", "")} className="default-btn red-btn" onClick={acceptAlert}>
              Yes
            </button>

            <Button id={commonService.generateGlobalClickTrackerID("ConfirmationAlertModal", "no-cancel", "")} className="default-btn secondary-btn" onClick={denyAlert}>
              No, Cancel
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ConfirmationAlertModal;
